import { Component, Input } from '@angular/core';
import { File } from './shared/file.model';

@Component({
  selector: 'store-files',
  template: `
    @for (file of files; track file) {
      <div class="va-files file-list-container">
        <mat-icon class="file-icon">insert_drive_file</mat-icon>
        <a [href]="file.url" target="_blank">{{ file.name }}</a>
      </div>
    }
    `,
  styleUrls: ['./files.component.scss'],
  standalone: false,
})
export class VaFilesComponent {
  @Input() files: File[];
}
